// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IItemTypeDescription {
  identifier: string;
  category?: string;
}
